import React from 'react';
import ClassNames from 'classnames';
import WindowListenable from 'mixins/js/WindowListeners';
import KeyCode from 'utils/key-code';
import Calendar from 'components/date-picker/Calendar';
import DialogWindow from 'components/dialog/DialogWindow';
import FlatButton from 'components/buttons/flat-button/FlatButton';

export default React.createClass({

  mixins: [WindowListenable],

  propTypes: {
    initialDate: React.PropTypes.object,
    onAccept: React.PropTypes.func,
    onShow: React.PropTypes.func,
    onDismiss: React.PropTypes.func,
    timeOffset: React.PropTypes.array,
    maxDate: React.PropTypes.object,
    minDate: React.PropTypes.object,
    timePicker: React.PropTypes.bool,
    mode: React.PropTypes.oneOf(['portrait', 'landscape', 'inline']),


  },

  windowListeners: {
    'keyup': '_handleWindowKeyUp'
  },

  getInitialState() {
    return {
      isCalendarActive: false
    };
  },

  render() {
    let {
      initialDate,
      onAccept,
      timeOffset,
      maxDate,
      minDate,
      timePicker,
      mode,
    } = this.props;

    let classes = ClassNames('lui-date-picker-dialog');

    let actions = [
      <FlatButton
        key={0}
        label="Cancel"
        status="secondary"
        onClick={this._handleCancelTouchTap} />,
      <FlatButton
        key={1}
        label="OK"
        status="secondary"
        onClick={this._handleOKTouchTap} />
    ];

    return (
      <DialogWindow {...this.props}
        ref="dialogWindow"
        className={classes}
        actions={actions}
        contentClassName="lui-date-picker-dialog-window"
        onDismiss={this._handleDialogDismiss}
        onShow={this._handleDialogShow}
        repositionOnUpdate={false}>
        <Calendar
          ref="calendar"
          timeOffset={timeOffset}
          initialDate={this.props.initialDate}
          isActive={this.state.isCalendarActive}
          maxDate={maxDate}
          minDate={minDate} 
          timePicker={timePicker}
          mode={mode} />
      </DialogWindow>
    );
  },

  show() {
    this.refs.dialogWindow.show();
  },

  dismiss() {
    this.refs.dialogWindow.dismiss();
  },

  _handleCancelTouchTap() {
    this.dismiss();
  },

  _handleOKTouchTap() {
    this.dismiss();
    if (this.props.onAccept) {
      this.props.onAccept(this.refs.calendar.getSelectedDate());
    }
  },

  _handleDialogShow() {
    this.setState({
      isCalendarActive: true
    });

    if(this.props.onShow) {
      this.props.onShow();
    }
  },

  _handleDialogDismiss() {
    this.setState({
      isCalendarActive: false
    });

    if(this.props.onDismiss) {
      this.props.onDismiss();
    }
  },

  _handleWindowKeyUp(e) {
    if (this.refs.dialogWindow.isOpen()) {
      switch (e.keyCode) {
        case KeyCode.ENTER:
          this._handleOKTouchTap();
          break;
      }
    } 
  }

});


/** WEBPACK FOOTER **
 ** ./src/components/date-picker/DatePickerDialog.js
 **/